<div class="dashboard-metrics" *ngIf="!isLoading">
  <div class="metric-box" 
       *ngFor="let metric of metrics; let i = index" 
       [ngStyle]="{'--accent': accentColors[i]}" 
       (click)="onMetricClick(metric.label)"
       tabindex="0"
       role="button"
       [attr.aria-label]="'View ' + metric.label + ' details. Current count: ' + metric.count + '. Trend: ' + getTrendLabel(metric.trend)">
    <div class="metric-accent"></div>
    <div class="metric-content">
      <div class="metric-icon">
        <ng-container [ngSwitch]="i">
          <i *ngSwitchCase="0" class="fa fa-bars" aria-hidden="true"></i> <!-- Devices - Hamburger menu -->
          <i *ngSwitchCase="1" class="fa fa-check-circle" aria-hidden="true"></i> <!-- Active - Check circle -->
          <i *ngSwitchCase="2" class="fa fa-user" aria-hidden="true"></i> <!-- Consumed - User icon -->
          <i *ngSwitchCase="3" class="fa fa-exclamation-circle" aria-hidden="true"></i> <!-- Missing - Exclamation circle -->
          <i *ngSwitchCase="4" class="fa fa-ban" aria-hidden="true"></i> <!-- Expired - Ban/stop symbol -->
          <i *ngSwitchCase="5" class="fa fa-cog" aria-hidden="true"></i> <!-- Expiring in 30 Days - Gear -->
          <i *ngSwitchCase="6" class="fa fa-star" aria-hidden="true"></i> <!-- Low Stock - Star -->
          <i *ngSwitchCase="7" class="fa fa-car" aria-hidden="true"></i> <!-- Transit - Car -->
          <i *ngSwitchDefault class="fa fa-bar-chart" aria-hidden="true"></i>
        </ng-container>
      </div>
      <div class="metric-info">
        <div class="metric-count">{{metric.count}}</div>
      </div>
      <div class="metric-bottom">
        <div class="metric-label">{{metric.label}}</div>
        <div class="metric-trend" 
             *ngIf="metric.label !== 'Devices'"
             [ngClass]="getTrendClass(metric.trend)"
             [attr.aria-label]="'Trend: ' + getTrendLabel(metric.trend)">
          <span class="trend-text">{{metric.percent}}%</span>
          <span class="trend-icon" 
                [ngClass]="getTrendClass(metric.trend)"
                [attr.aria-label]="getTrendLabel(metric.trend)">
            {{getTrendIcon(metric.trend)}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
